import _ from 'lodash';
import Moment from 'moment';
import {
  FORMAT_DATE_AND_TIME,
  toUniversalDate,
  toUniversalUtcDate,
} from './date.utils';

export const prepFileContent = (data: any, columns: any) => {
  const tableDataString = mapTableDataWithDataMap(data, columns).join('\n');
  const headerDataString = columns
    .filter(
      (col: any) =>
        (!!col.label || !!col.title) &&
        (col.show === undefined || col.show || col.alwaysInCsv) &&
        !col.ommitInCsv
    )
    .map((obj: any) => obj.label || obj.title)
    .join(',');
  return [headerDataString, '\n', tableDataString];
};
export const mapTableDataWithDataMap = (data: any, columns: any) => {
  return data.map((row: any) =>
    columns
      .filter(
        (col: any) =>
          (!!col.label || !!col.title) &&
          (col.show === undefined || col.show || col.alwaysInCsv) &&
          !col.ommitInCsv
      )
      .map((column: any) => {
        let content = _.get(row, column.name);
        if (typeof column.csv === 'function') {
          content = column.csv(row);
        }

        if (!content) {
          return '';
        }

        // enclose cell value with double quotes and escape any double quotes in the value
        return `"${content.toString().replace(/"/g, '""')}"`;
      })
      .join(',')
  );
};
export const startDownload = ({ data, columns, filename }: any) => {
  return new Promise((resolve) => {
    const fileContentArray = prepFileContent(data, columns);
    const csvFile = new Blob(fileContentArray, { type: 'text/csv' });
    resolve({ csvFile, filename });
  });
};
export const handleDownload = ({ csvFile, filename }: any) => {
  // Download link
  const downloadLink = document.createElement('a');
  // Make sure that the link is not displayed
  downloadLink.style.display = 'none';
  // File name
  downloadLink.download = filename;
  // We have to create a link to the file
  downloadLink.href = window.URL.createObjectURL(csvFile);
  // Add the link to your DOM
  document.body.appendChild(downloadLink);
  // Lanzamos
  downloadLink.click();
};
export const getShortDateString = (date: any) => {
  return toUniversalDate(date, { placeholder: '' });
};
export const getShortDateTimeFromUtc = (date: any) => {
  return toUniversalUtcDate(date, { placeholder: '' });
};
export const getDateString = (date: any) => {
  return toUniversalUtcDate(date, {
    format: FORMAT_DATE_AND_TIME,
    placeholder: '',
  });
};

export const getLocalDateString = (date: any) => {
  if (!date) {
    return '';
  }
  return Moment(date).format(FORMAT_DATE_AND_TIME);
};
